import React, { useState } from "react";
import { DropDownOption } from "./types";

const DropDownItem = ({
  option,
  isSelected = false,
  onClick,
}: {
  option: DropDownOption;
  isSelected: boolean;
  onClick: (id: string) => void;
}) => {
  const [optionId] = useState(option.id || option.value);
  const handleSelected = () => {
    onClick(optionId as string);
  };

  return (
    <div
      className={`option ${isSelected ? "selected" : ""}`}
      id={"drop-down-option-" + optionId}
      key={optionId}
      onClick={handleSelected}
    >
      <p className="option-text" key={optionId}>
        {option.label}
      </p>
    </div>
  );
};

export default DropDownItem;
